import { useTranslation } from "react-i18next";
import GenericComponent from "../../utils/genericComponent/GenericComponent";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as Image } from "../../../assets/img/signing-illustration.svg";
import { ReactComponent as Devices } from "../../../assets/img/icons/devices.svg";
import googlePlay_IT from "../../../assets/img/store/google-play/google-play-badge-it.png";
import googlePlay_DE from "../../../assets/img/store/google-play/google-play-badge-de.png";
import googlePlay_FR from "../../../assets/img/store/google-play/google-play-badge-fr.png";
import googlePlay_EN from "../../../assets/img/store/google-play/google-play-badge-en.png";
import appStore_IT from "../../../assets/img/store/app-store/app-store-badge-it.svg";
import appStore_DE from "../../../assets/img/store/app-store/app-store-badge-de.svg";
import appStore_FR from "../../../assets/img/store/app-store/app-store-badge-fr.svg";
import appStore_EN from "../../../assets/img/store/app-store/app-store-badge-en.svg";
import { store } from "../../../redux/store";

import { FieldGroup, FieldRow, FieldSet, Section } from "react-corner-ds";
import style from "./VideoIdentification.module.css";
const ContractView = () => {
  const { t } = useTranslation();
  const [googlePlayIcon, setGooglePlayIcon] = useState<string>();
  const [appStoreIcon, setappStoreIcon] = useState<string>();
  const [isGooglePlayEN, setGooglePlayEN] = useState<boolean>(false);
  const { i18n } = useTranslation();

  const DEFAULT_WINDOWS_WIDTH = 768;

  const [isDesktop, setDesktop] = useState(
    window.innerWidth > DEFAULT_WINDOWS_WIDTH
  );
  const updateMedia = () => {
    setDesktop(window.innerWidth > DEFAULT_WINDOWS_WIDTH);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

  useEffect(() => {
    switch (i18n.resolvedLanguage) {
      case "it":
        setGooglePlayIcon(googlePlay_IT);
        setappStoreIcon(appStore_IT);
        setGooglePlayEN(false);
        break;
      case "de":
        setGooglePlayIcon(googlePlay_DE);
        setappStoreIcon(appStore_DE);
        setGooglePlayEN(false);
        break;
      case "fr":
        setGooglePlayIcon(googlePlay_FR);
        setappStoreIcon(appStore_FR);
        setGooglePlayEN(false);
        break;
      default:
        setGooglePlayIcon(googlePlay_EN);
        setappStoreIcon(appStore_EN);
        setGooglePlayEN(true);
        break;
    }
  }, [i18n]);

  const buildButtonContent = useMemo(
    () => (
      <>
        <div className={style.iconsContainer}>
          <FieldRow>
            <FieldGroup customCssClass={style.fieldGroupApple}>
              <a
                href="https://apps.apple.com/ch/app/idnow-online-ident/id918081242"
                target="_blank"
                rel="noreferrer"
                onClick={() => postMessage("success")}
              >
                <img alt="Get it on Google Play" src={appStoreIcon} />
              </a>
            </FieldGroup>
          </FieldRow>
          <FieldRow>
            <FieldGroup customCssClass={style.fieldGroupGoogle}>
              <a
                href="https://play.google.com/store/apps/details?id=de.idnow"
                target="_blank"
                rel="noreferrer"
                onClick={() => postMessage("success")}
              >
                <img
                  alt="Get it on Google Play"
                  src={googlePlayIcon}
                  className={isGooglePlayEN ? style.fixedHeight : ""}
                />
              </a>
            </FieldGroup>
          </FieldRow>
        </div>
      </>
    ),
    [appStoreIcon, googlePlayIcon, isGooglePlayEN]
  );

  return isDesktop ? (
    <>
      <GenericComponent
        ImageSrc={Image}
        pageTitle={t`screens.videoId.pageTitle`}
        pageSubtitle={t`screens.videoId.pageSubtitle`}
        transComponent={{ br: <br /> }}
        buttonLabel={t`screens.videoId.singBtn`}
        onClickCallback={() =>
          (window.location.href =
            store.getState().pega.Data.Bank.IdentityVerification
              ?.VideoIdentificationShortLink ?? "")
        }
      />
      <Section>
        <FieldSet>
          <FieldRow customCssClass={style.videoIdAsset}>
            <FieldGroup customCssClass={style.videoIdGroupIcons}>
              <Devices />
            </FieldGroup>
            <FieldGroup
              customCssClass={style.videoIdGroup}
            >{t`screens.videoId.asset`}</FieldGroup>
          </FieldRow>
        </FieldSet>
      </Section>
    </>
  ) : (
    <>
      <GenericComponent
        ImageSrc={Image}
        pageTitle={t`screens.videoId.pageTitle`}
        pageSubtitle={t`screens.videoId.mobileSubtitle`}
        transComponent={{
          br: <br />,
          TICKET:
            store.getState().pega.Data?.Bank.IdentityVerification
              ?.VideoIdentificationTicket ?? "-",
          b: <strong></strong>,
        }}
      />
      <Section customCssClass={style.videoIdMobile}>
        <FieldSet>
          {buildButtonContent}
          <div className={style.videoIdAssetContainer}>
            <FieldRow customCssClass={style.videoIdAsset}>
              <FieldGroup customCssClass={style.videoIdGroupIcons}>
                <Devices />
              </FieldGroup>
            </FieldRow>
            <FieldRow customCssClass={style.videoIdAsset}>
              <FieldGroup
                customCssClass={style.videoIdGroup}
              >{t`screens.videoId.asset`}</FieldGroup>
            </FieldRow>
          </div>
        </FieldSet>
      </Section>
    </>
  );
};

export default ContractView;
